export default __webpack_public_path__ + "03ffc632522f14f69135b03a9e9f39e2.png";